// Helper functions for pagination

/**
 * Get paginated hotels
 * @param {Array} hotels - The array of hotels
 * @param {number} hotelPage - The current page number
 * @param {number} hotelsPerPage - The number of hotels per page
 * @returns {Array} - The paginated hotels
 */
export const getPaginatedHotels = (hotels, hotelPage, hotelsPerPage) => {
  if (!Array.isArray(hotels)) {
    return [];
  }
  const startIndex = (hotelPage - 1) * hotelsPerPage;
  return hotels.slice(startIndex, startIndex + hotelsPerPage);
};

/**
 * Handle page change
 * @param {number} newPage - The new page number
 * @param {Function} setHotelPage - State setter for hotel page
 */
export const handlePageChange = (newPage, setHotelPage) => {
  setHotelPage(newPage);
  const hotelListElement = document.querySelector('.hotels-list');
  if (hotelListElement) {
    hotelListElement.scrollIntoView({ behavior: 'smooth' });
  }
};

/**
 * Get total pages
 * @param {Array} hotels - The array of hotels
 * @param {number} hotelsPerPage - The number of hotels per page
 * @returns {number} - The total number of pages
 */
export const getTotalPages = (hotels, hotelsPerPage) => {
  return Array.isArray(hotels) ? Math.ceil(hotels.length / hotelsPerPage) : 0;
};

export default {
  getPaginatedHotels,
  handlePageChange,
  getTotalPages
};